import { createFileRoute } from '@tanstack/react-router'
import { AdminLoyaltySettings } from '@/components/admin/marketing/AdminLoyaltySettings'

export const Route = createFileRoute('/admin/marketing/loyalty')({
  component: () => <AdminLoyaltySettings />,
})
